





























































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import Empty from "@/components/empty.vue";
import { GetExamResultStatic } from "@/request/common";
@Component({
  components: {
    Header,
    LeftNav,
    Empty,
  },
})
export default class Name extends Vue {
  private id: any = "";
  private data: any = {};
  private optionData: any = {};
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      exam_id: this.id,
    };
    GetExamResultStatic(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res;
        this.drawFenbu();
        this.drawTongji();
      })
      .catch(() => {
        loading.close();
      });
  }
  private drawFenbu() {
    this.optionData = {
      color: ["#3387FF"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      grid: {
        top: "20px",
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: this.data["成绩分布图"].name,
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: "value",
        },
      ],
      series: [
        {
          name: "人数",
          type: "bar",
          data: this.data["成绩分布图"].data,
          barWidth: "30",
          itemStyle: {
            barBorderRadius: 15,
          },
        },
      ],
    };
  }
  private drawTongji() {
    this.data["答题内容统计"].forEach((ele: any) => {
      ele.optionChart = {
        color: ["#3387FF"],
        title: {
          text: "答题正确率分布",
          textStyle: {
            fontWeight: "normal",
            fontSize: "14px",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: (val: any) => {
            return val[0].name + "</br>" + "分布占比: " + val[0].value + "%";
          },
        },
        grid: {
          top: "60px",
          left: "3%",
          right: "140px",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            name: "答题正确率分布区间",
            type: "category",
            data: ele["答题正确率分布"].name,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            name: "分布占比",
            type: "value",
            axisLabel: {
              formatter: (val: any) => {
                return val + "%";
              },
            },
          },
        ],
        series: [
          {
            name: "分布占比",
            type: "bar",
            data: ele["答题正确率分布"].data,
            barWidth: "30",
            itemStyle: {
              barBorderRadius: 15,
            },
          },
        ],
      };
    });
  }
  private preview(url: any) {
    window.open(url);
  }
  private mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getData();
    }
  }
}
